import React from 'react';

const EmptyConent = () => <div className="empty-content">No options</div>;

export default EmptyConent;
